import manualDataRaw from '../data/manual-utilizare.json';
import manualData2Raw from '../data/manual-utilizare2.json';
import manualData3Raw from '../data/manual-utilizare3.json';

export interface ManualStep {
    numar: number;
    titlu: string;
    descriere: string;
    subsectiuni?: ManualSubSection[];
    pasi?: string[];
    observatii?: string[];
    urmatorul_pas?: string;
    screenshot_landing?: string;
    subtitlu_principal?: string;
    observatii_generale?: string[];
    screenshot_principal?: string;

    // New fields from manual 2
    // New fields from manual 2
    pasi_suplimentari?: ManualStep[]; // Although seemingly flat in JSON, just in case
    observatii_finale?: string[]; // Added this line
}

export interface ManualSubSection {
    subtitlu: string;
    descriere?: string;
    pasi?: string[];
    pasi_detaliat?: string[];
    screenshot?: string;
    nota?: string;

    // Extended fields
    explicatie_copil?: string;
    observatii_generale?: string[];
    total_coduri?: string;
    coduri_disponibile?: Array<{ "nume": string; "cod_tehnic": string; "pentru_ce": string; "examene": Array<string>; "articole": string; "exemple_subiecte": string }>;
    filtre_examen?: { "descriere": string; "explicatie_copil": string; "optiuni": { "Toate": { "ce_arata": string; "pentru_cine": string }; "INM": { "ce_arata": string; "coduri_incluse": Array<string>; "coduri_excluse": Array<string>; "pentru_cine": string }; "Barou": { "ce_arata": string; "coduri_incluse": Array<string>; "coduri_excluse": Array<string>; "pentru_cine": string } }; "cum_folosesti": string; "beneficiu": string };
    pasi_utilizare?: Array<{ "pas": number; "titlu": string; "descriere": string; "actiune"?: string; "explicatie_copil"?: string; "ce_se_intampla"?: string | Array<string>; "exemplu"?: string; "detalii_tehnice"?: { "ce_citeste": string; "text_curatat": string; "exemplu": string }; "ce_poti_face"?: Array<string>; "detalii"?: Array<string> | { "continut_prompt": Array<string>; "lungime_prompt": string; "format": string }; "controale_disponibile"?: { "Play_Pause": { "buton": string; "actiune": string; "explicatie": string; "detaliu": string }; "Skip_Back": { "buton": string; "actiune": string; "explicatie": string; "detaliu": string }; "Skip_Forward": { "buton": string; "actiune": string; "explicatie": string; "detaliu": string }; "Viteza": { "buton": string; "actiune_minus": string; "actiune_plus": string; "interval": string; "default": string; "explicatie_copil": string; "exemple_utilizare": Array<string> } }; "info_suplimentare"?: string; "exemple"?: Array<string>; "recomandare"?: string | Array<string>; "detalii_card_speta"?: { "checkbox": string; "titlu": string; "materie": string; "vezi_detalii": string; "sterge": string }; "selectie_automata"?: string; "ce_vezi"?: Array<string>; "nota"?: string; "exemplu_text"?: string; "beneficiu"?: string; "timp_generare"?: string; "actiuni_disponibile"?: { "Copiaza_Textul": { "buton": string; "actiune": string; "explicatie_copil": string; "ce_se_intampla": string }; "Descarca_DOCX": { "buton": string; "actiune": string; "explicatie_copil": string; "ce_se_intampla": Array<string>; "beneficiu": string }; "Descarca_TXT": { "buton": string; "actiune": string; "explicatie_copil": string; "ce_se_intampla": Array<string>; "beneficiu": string } }; "ce_primesti"?: Array<string>; "tipuri_acceptate"?: Array<string>; "rezultat"?: string }>; // Richer steps object
    detalii_tehnice?: { "ce_citeste"?: string; "text_curatat"?: string; "exemplu"?: string; "ce_face_ai_ul"?: string; "curatare_inteligenta"?: string; "reconstructie"?: string };
    ce_poti_face?: string[];
    detalii?: string[];
    controale_disponibile?: { "Play_Pause": { "buton": string; "actiune": string; "explicatie": string; "detaliu": string }; "Skip_Back": { "buton": string; "actiune": string; "explicatie": string; "detaliu": string }; "Skip_Forward": { "buton": string; "actiune": string; "explicatie": string; "detaliu": string }; "Viteza": { "buton": string; "actiune_minus": string; "actiune_plus": string; "interval": string; "default": string; "explicatie_copil": string; "exemple_utilizare": Array<string> } };
    beneficii_principale?: Array<string | { "beneficiu": string; "explicatie": string; "exemple"?: string | Array<string>; "comparatie"?: string; "beneficiu_suplimentar"?: string; "studii"?: string; "detalii"?: string; "caz_utilizare"?: string; "siguranta"?: Array<string> }>; // Can be strings or objects
    cazuri?: Array<{ "profil": string; "rutina_zilnica": { "dimineata"?: string; "pranz"?: string; "seara"?: string; "weekend"?: string; "deplasari_clienti"?: string; "sala_sport"?: string; "acasa_seara"?: string; "final_examen"?: string }; "rezultat": string; "feedback": string }>;
    observatii_finale?: string[];
    context?: string;
    actiuni_disponibile?: { "Partajare"?: { "descriere": string; "iconita": string; "cum_folosesti": Array<{ "pas": number; "actiune": string }>; "explicatie_copil": string; "cazuri_utilizare": Array<string> }; "Redenumire"?: { "descriere": string; "iconita": string; "cum_folosesti": Array<{ "pas": number; "actiune": string }>; "explicatie_copil": string; "exemple": Array<string> }; "Stergere"?: { "descriere": string; "iconita": string; "cum_folosesti": Array<{ "pas": number; "actiune": string; "detaliu"?: string }>; "explicatie_copil": string; "atentie": Array<string> }; "Copiaza_Textul"?: { "buton": string; "actiune": string; "explicatie_copil": string; "ce_se_intampla": string }; "Descarca_DOCX"?: { "buton": string; "actiune": string; "explicatie_copil": string; "ce_se_intampla": Array<string>; "beneficiu": string }; "Descarca_TXT"?: { "buton": string; "actiune": string; "explicatie_copil": string; "ce_se_intampla": Array<string>; "beneficiu": string } };
    observatii_suplimentare?: string[];
    exemple?: string[];
    recomandare?: string | string[];

    // Fields from manual-utilizare.json (Legacy but Rich)
    metode?: Array<{ "tip": string; "pasi": Array<string>; "screenshot": string; "nota"?: string }>;
    tipuri_abonament?: Array<{ "tip": string; "denumire_afisata": string; "pret": string; "descriere": string; "functionalitati": Array<string>; "limitari"?: Array<string>; "cum_se_acceseaza"?: string; "cum_se_obtine"?: Array<string>; "nota_importanta"?: string }>;
    erori?: Array<{ "mesaj": string; "cauza": string; "solutie": string }>;
    erori_comune?: Array<{ "mesaj": string; "cand_apare": string; "screenshot"?: string; "solutie": Array<string> }>;
    tipuri_cautare?: Array<{ "tip": string; "culoare_card": string; "icon": string; "descriere_simpla": string; "ce_poti_cauta"?: Array<string>; "exemple_corecte"?: Array<string>; "exemple_gresite"?: Array<string>; "cum_se_foloseste": Array<string>; "ce_gasesti": Array<string>; "screenshot": string; "nota_importanta"?: string; "atentie_foarte_important"?: { "mesaj": string; "explicatie_pentru_copii": Array<string>; "ce_nu_poti_face": Array<string>; "ce_poti_face": Array<string> }; "reguli_obligatorii"?: Array<{ "regula": string; "explicatie": string; "de_ce": string; "ce_se_intampla_daca_nu_respecti": string; "screenshot": string }>; "exemplu_complet_real"?: { "titlu": string; "text": string; "numar_caractere": string; "de_ce_e_bun": string }; "buton_rapid"?: string }>;
    pasi_generali?: string[];
    shortcut_exemple_rapide?: string[];
    limite_acces?: Array<{ "tip_cont": string; "limite": string; "mesaj_afisat"?: string; "cum_obtin_mai_mult"?: string; "beneficii_extra"?: Array<string> }>;
    zone_principale?: Array<{ "zona": string; "ce_contine": Array<string> | string; "screenshot"?: string; "explicatie_butoane"?: { "Dosar": string; "Share": string; "Print": string; "Download": string; "Close_X": string }; "explicatie"?: string; "lista_tab_uri"?: Array<string> }>;
    taburi_detaliate?: Array<{ "numar": number; "nume_tab": string; "icon_culoare": string; "pentru_ce_e_util": string; "ce_gasesti_aici": Array<{ "camp"?: string; "explicatie"?: string; "subsectiune"?: string; "explicatie_copil"?: string; "explicatie_tehnica"?: string; "exemplu"?: string; "atentie"?: string; "culoare"?: string; "nota"?: string } | string>; "screenshot"?: string; "beneficiu_pentru_utilizator": string; "functionalitate_speciala"?: { "nume": string; "screenshot": string; "cum_functioneaza": Array<string>; "statistici_afișate": Array<string>; "beneficiu": string }; "nota"?: string; "tipuri_modele"?: Array<string>; "coduri_posibile"?: Array<string>; "explicatie_copil"?: string; "exemplu"?: string; "atentie_speciala"?: string; "explicatie_tehnica"?: string; "limit_acces"?: string }>;
    butoane_detaliate?: Array<{ "buton": string; "icon": string; "culoare"?: string; "ce_face": Array<string> | string; "cum_folosești"?: Array<string>; "beneficiu": string; "shortcut_tastatura"?: string }>;
    functionalitate_speciala?: { "nume": string; "screenshot": string; "cum_functioneaza": Array<string>; "statistici_afișate": Array<string>; "beneficiu": string };

    [key: string]: unknown; // Additional manual metadata is not rendered without narrowing.
}

export interface ManualData {
    manual_utilizare: {
        titlu: string;
        versiune: string;
        data_creare: string;
        descriere: string;
        pasi: ManualStep[];
    };
}

interface ManualData2 {
    pasi_suplimentari: ManualStep[];
}

const manual1 = manualDataRaw as ManualData;
const manual2 = manualData2Raw as ManualData2;
const manual3 = manualData3Raw as ManualData2;

// Merge logic: Combine steps. If a step number exists in manual2, it overrides manual1 (richer data).
const mergedStepsMap = new Map<number, ManualStep>();

manual1.manual_utilizare.pasi.forEach(step => {
    mergedStepsMap.set(step.numar, step);
});

if (manual2.pasi_suplimentari) {
    manual2.pasi_suplimentari.forEach(step => {
        mergedStepsMap.set(step.numar, step);
    });
}

if (manual3.pasi_suplimentari) {
    manual3.pasi_suplimentari.forEach(step => {
        mergedStepsMap.set(step.numar, step);
    });
}

const mergedSteps = Array.from(mergedStepsMap.values()).sort((a, b) => a.numar - b.numar);

// Create a synthetic ManualData object
const manualData: ManualData = {
    manual_utilizare: {
        ...manual1.manual_utilizare,
        pasi: mergedSteps
    }
};

export const getManualStepByPath = (path: string): ManualStep | null => {
    const steps = manualData.manual_utilizare.pasi;
    const normalizedPath = path.toLowerCase();

    // 1. Auth
    if (
        normalizedPath === '/login' ||
        normalizedPath === '/register' ||
        normalizedPath === '/forgot-password' ||
        normalizedPath === '/complete-profile' ||
        normalizedPath === '/verify-email'
    ) {
        return steps.find(s => s.numar === 1) || null;
    }

    // 2. Search
    if (
        normalizedPath === '/' ||
        normalizedPath === '/cautare' ||
        normalizedPath.startsWith('/cautare')
    ) {
        return steps.find(s => s.numar === 2) || null;
    }

    // 3. Case Details handled via context

    // 4. Audio Grile
    if (normalizedPath === '/audio-grile' || normalizedPath.startsWith('/audio-grile')) {
        return steps.find(s => s.numar === 4) || null;
    }

    // 5. Audio Legislatie
    if (normalizedPath === '/audio-legislatie' || normalizedPath.startsWith('/audio-legislatie')) {
        return steps.find(s => s.numar === 5) || null;
    }

    // 6. Dosare? (Usually modal based, but maybe a route exists?)
    // If there is a dedicated route for dosare, add it here.
    // Assuming Dosare is mostly a Drawer/Modal feature accessible everywhere.

    // 7. Conversie PDF
    if (
        normalizedPath === '/convertpdf' ||
        normalizedPath.startsWith('/convertpdf')
    ) {
        return steps.find(s => s.numar === 7) || null;
    }

    // 8. Jurnal Juridic
    if (
        normalizedPath === '/stiri' ||
        normalizedPath.startsWith('/stiri') ||
        normalizedPath === '/evenimente' ||
        normalizedPath === '/editura' ||
        normalizedPath === '/cariere' ||
        normalizedPath === '/profesionisti'
    ) {
        return steps.find(s => s.numar === 8) || null;
    }

    // 9. Perspective Juridice
    if (
        normalizedPath === '/perspective-juridice' ||
        normalizedPath.startsWith('/perspective-juridice')
    ) {
        return steps.find(s => s.numar === 9) || null;
    }

    return null;
};

export const getManualStepById = (id: number): ManualStep | null => {
    return manualData.manual_utilizare.pasi.find(s => s.numar === id) || null;
};

export { manualData };
